<template>
    <v-card-actions class="d-flex pa-0 ma-0 transparent" width="100%" :disabled="gamefinished">
        <v-btn v-if="element.deletable" class="timelineItemDelete theme-background theme-border pa-0" min-width="44px" height="44px" tile depressed @click="deleteAction">
            <v-icon class="theme-text">mdi-trash-can-outline</v-icon>
        </v-btn>
        <v-btn v-if="element.deletable && element.action === 'Felmegy'" class="timelineItemDelete theme-background theme-border pa-0" min-width="44px" height="44px" tile depressed @click="editAction">
            <v-icon class="theme-text">mdi-pencil</v-icon>
        </v-btn>
        <v-btn class="theme-background theme-border theme-text flex-grow-1 pa-0 ma-0 timelineItemCancel" min-height="44px" tile depressed @click="closeEditing">Mégsem</v-btn>
        <v-btn v-if="element.action === 'Csere' || element.action === 'Felmegy'" :disabled="!save" class="theme-background theme-border theme-text flex-grow-1 pa-0 ma-0 timelineItemSave" min-height="44px" tile depressed @click="saveAction">Mentés</v-btn>
    </v-card-actions>
</template>

<script>
    import eventBus from '@/eventBus';
    import CONSTANTS from '@/constants';

    export default {
        name: 'TimelineAction',
        props: {
            element: Object,
            team: String,
            gamefinished: Boolean
        },
        methods: {
            deleteAction: function() {
                let players = {
                    up: this.element.up ? this.element.up : null,
                    down: this.element.down ? this.element.down : null
                };
                eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.DELETE.ONE, this.element.UUID, players, this.team);
            },
            closeEditing: function() {
                eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.CLOSE, this.element);
            },
            editAction: function() {
                eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.EDIT.UP, this.element, this.team);
            },
            saveAction: function() {
                let players = {
                    up: this.element.up ? this.element.up : null,
                    down: this.element.down ? this.element.down : null
                };

                if(this.element.action === 'Felmegy') {
                    players.down = null;
                }
                eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.SAVE.ONE, this.element.UUID, players, this.team, true);
            },
        },
        computed: {
            save() {
                let self = this;
                let rtn = Boolean(self.element.down);

                if(rtn && self.element.action === "Csere" && !self.element.up) {
                    rtn = false;
                }

                if(self.element.action === "Felmegy") {
                    rtn = true;
                }

                return rtn;
            },
        },
    }
</script>

<style scoped>
    .v-btn {
        border-style: solid;
        border-width: 1px;
    }

    @media only screen and (max-width: 1200px) {
        .timelineItemCancel, .timelineItemSave {
            font-size: 12px;
            font-stretch: condensed;
        }

        .timelineItemDelete {
            width: 32px !important;
            min-width: 32px !important;
        }
    }
</style>

<style>
    .timelineItemDelete {
        width: 44px;
        height: 44px;
        border-style: solid;
        border-width: 1px;
        margin: 0 !important;
    }

    .timelineItemDelete + .timelineItemCancel {
        border-left-width: 0 !important;
    }
    .timelineItemSave {
        border-left-width: 0 !important;
    }
</style>
